import { Checkbox as AntdMobileCheckbox } from "antd-mobile";
import { BaseCheckboxProps } from "./Checkbox.types";
import "./Checkbox.scss";

export const Checkbox: React.FC<BaseCheckboxProps> = ({
  children,
  variant = "primary",
  size = "md",
  checked,
  defaultChecked = false,
  disabled = false,
  indeterminate = false,
  onChange,
  className = "",
  testId,
  ...props
}) => {
  const checkboxClass = [
    "checkbox",
    `checkbox--${variant}`,
    `checkbox--${size}`,
    disabled && "checkbox--disabled",
    indeterminate && "checkbox--indeterminate",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <AntdMobileCheckbox
      className={checkboxClass}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      indeterminate={indeterminate}
      onChange={onChange}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdMobileCheckbox>
  );
};

export default Checkbox;
